@if (!isSimpleMode) {
  <!-- Card Mode: Rich tooltip with icon, title, description, and action -->
  <div class="custom-tooltip-card" role="dialog" [attr.aria-label]="title">
    @if (icon) {
      <div class="tooltip-icon" aria-hidden="true">
        <mat-icon [fontIcon]="icon" />
      </div>
    }

    @if (title) {
      <h3 class="tooltip-title">{{ title }}</h3>
    }

    @if (description) {
      <p class="tooltip-description">{{ description }}</p>
    }

    @if (hasAction) {
      <button
        mat-button
        type="button"
        class="tooltip-action"
        [attr.aria-label]="actionText"
        (click)="onActionClick()">
        {{ actionText }}
        <mat-icon class="action-icon">arrow_forward</mat-icon>
      </button>
    }
  </div>
} @else {
  <!-- Simple Mode: Text-only tooltip -->
  <div class="custom-tooltip-simple">{{ text }}</div>
}
